import React, { useEffect, useRef, useState } from "react";

const PercentageCard = ({ index, percent, label }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) setVisible(true);
      },
      { threshold: 0.4 }
    );

    if (ref.current) observer.observe(ref.current);
  }, []);

  return (
    <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} ref={ref} className="text-center w-full">
      <p className="text-6xl font-extrabold text-transparent stroke-[2px] stroke-black">
        {percent}%
      </p>

      <p className="text-sm mt-2 text-primaryColor font-semibold">{label}</p>

      <div className="w-full h-3 bg-gray-200 rounded-full mt-4 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-primaryColor to-primaryFadedColor rounded-full transition-all duration-[1500ms]"
          style={{ width: visible ? `${percent}%` : "0%" }}
        ></div>
      </div>
    </div>
  );
};

export default PercentageCard;
